import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

import { ApplicationInspectionFileApiService } from '../index';
import { IApplicationInspectionFile, IApplicationInspectionFileInput } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { 
  GetApplicationInspectionFilesByIdQuery,
  SaveApplicationInspectionFileMutation 
} from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })
  export class ApplicationInspectionFileGqlService implements ApplicationInspectionFileApiService {

    constructor(
      private apollo: Apollo
    ) { }
  
    public list(applicationId: string): Observable<IApplicationInspectionFile[]> {
      //console.log(`ApplicationInspectionFileApi.list()`);
      return this.apollo
        .query({
          query: GetApplicationInspectionFilesByIdQuery,
          variables: {
            applicationId: applicationId
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
            map(result => result.data['applicationInspectionFiles'] as IApplicationInspectionFile[])
        );
    }

    public update(applicationInspectionFile: IApplicationInspectionFileInput, applicationInspectionFileId: string | '') : Observable<IApplicationInspectionFile> {
      //console.log(`ApplicationInspectionFileApi.update()`);
      return this.apollo
        .mutate({
          mutation: SaveApplicationInspectionFileMutation,
          variables : {
            applicationInspectionFile,
            applicationInspectionFileId
          }
        })
        .pipe(map(result => result.data['saveApplicationInspectionFile'] as IApplicationInspectionFile));
    }

  }